import React, { createContext, useContext } from 'react';

// Create Auth Context
const AuthContext = createContext(null);

// Context Provider Component
export const AuthProvider = ({ children, value }) => {
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// Custom hook to use the auth context
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === null) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

// Helper to check if user has a specific role
export const hasRole = (keycloak, role) => {
  if (!keycloak?.authenticated || !keycloak?.tokenParsed) return false;

  // Check realm roles
  const realmRoles = keycloak.tokenParsed?.realm_access?.roles || [];
  if (realmRoles.includes(role)) return true;

  // Check client roles (deskbot-frontend)
  const clientRoles = keycloak.tokenParsed?.resource_access?.['deskbot-frontend']?.roles || [];
  return clientRoles.includes(role);
};

// Helper to check if user is admin
export const isAdmin = (keycloak) => hasRole(keycloak, 'admin');

// Session 10: super_admin — platform-wide role for /api/admin/* endpoints + cross-practice access.
// Granted via Keycloak (see init-keycloak.sh configure_roles + configure_admin_user).
// Backend equivalent: dependencies/auth.require_super_admin.
//
// `admin` alias: TenantContextMiddleware._is_super_admin_from_jwt grandfathers the legacy
// `admin` role as super_admin until the platform-admin alias is dropped (post-Session 10).
// Mirror that here so users holding only the `admin` role still see the practice selector +
// /admin/practices nav link. Drop both aliases together.
export const isSuperAdmin = (keycloak) => hasRole(keycloak, 'super_admin') || hasRole(keycloak, 'admin');
